import { Description, Field, Label } from "@headlessui/react";
import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";
import { IsRequiredStar } from "../FormControl/FormLabel";
import { FormError } from "../FormError";
import type { BaseCheckboxProps } from "./BaseCheckbox";
import { BaseCheckbox } from "./BaseCheckbox";

export type CheckboxProps = BaseCheckboxProps & {
	name: string;
	label?: React.ReactNode | string | null;
	labelClassName?: string;
	description?: React.ReactNode | string | null;
	error?: string;
	isRequired?: boolean;
	containerClassName?: string;
};

const CheckboxInner = (
	{
		label,
		labelClassName,
		description,
		error,
		name,
		isRequired,
		containerClassName,
		...checkboxProps
	}: CheckboxProps,
	ref: React.ForwardedRef<HTMLInputElement>,
) => {
	return (
		<div className={containerClassName}>
			<Field className="flex items-center gap-2">
				<BaseCheckbox {...checkboxProps} ref={ref} />
				{label && (
					<Label className={classNames("font-medium text-neutral text-sm", labelClassName)}>
						{label}
						{isRequired && <IsRequiredStar />}
					</Label>
				)}
			</Field>
			{description && (
				<Description className="mt-1 max-w-prose text-neutral-faded text-sm leading-5">
					{description}
				</Description>
			)}
			{error && <FormError className="mt-0.5" id={`${name.replace(/\./g, "-")}-error`} error={error} />}
		</div>
	);
};

CheckboxInner.displayName = "Checkbox";

export const Checkbox = forwardRef(CheckboxInner);
